<template>
  <div class="text-center w-100">
    <h3 style="color: #fff">{{ message}} <i class="fa fa-spinner fa-spin"></i></h3>

<!--    <img src="@/theme/images/loading.gif">-->
  </div>
</template>
<script>
export default {
  props:{
    "message":  {
      type: String,
      default: 'Loading ...'
    }
  }
}
</script>